/**
 * Removes consecutive duplicates of specified characters from a string.
 * @param chars Array of characters to remove consecutive duplicates for.
 * @param str The input string.
 * @returns The string with consecutive duplicates removed.
 */
export const removeConsecutive = (chars: string[], str: string): string => {
  if (!chars || !chars.length || typeof str !== 'string') {
    return str;
  }

  // Iterate over each character and replace consecutive duplicates
  let result = str;
  chars.forEach(char => {
    const regex = new RegExp(`(${char})\\1+`, 'g');
    result = result.replace(regex, '$1');
  });

  return result;
};
